import { render, staticRenderFns } from "./CardStyle.vue?vue&type=template&id=68789c47&scoped=true"
import script from "./CardStyle.vue?vue&type=script&lang=js"
export * from "./CardStyle.vue?vue&type=script&lang=js"
import style0 from "./CardStyle.vue?vue&type=style&index=0&id=68789c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68789c47",
  null
  
)

export default component.exports